export default class Pocket {
    constructor(pocketElement) {
        this.dom = {
            root: pocketElement,
            tapArea: pocketElement.querySelector('.pocket__tap-area'),
            button: pocketElement.querySelector('.pocket__button'),
        };
        this.isExpanded = !pocketElement.classList.contains('pocket--less');
    }

    expand() {
        this.dom.root.classList.remove('pocket--less');
        this.dom.button.innerText = __('fold');
        this.isExpanded = true;
        return true;
    }

    fold() {
        this.dom.root.classList.add('pocket--less');
        this.dom.button.innerText = __('expand');
        this.isExpanded = false;
        return true;
    }

    onClick() {
        if (this.isExpanded) {
            return this.fold();
        }
        return this.expand();
    }

    connect() {
        this.dom.tapArea.addEventListener('click', () => this.onClick());
    }
}
